import * as Phaser from "phaser-ce"
import { log } from "../../../../common/Logging"
import { Buttons } from "../../../generic-sprites/Buttons"
import { Scale } from "../../../utils/Scale"
import { HeroState } from "../HeroState"

export class Trashable extends Phaser.Sprite {

    on = false
    private appearanceTimer: Phaser.Timer

    /**
     * Related sprite and hide work independently of each other.
     *
     * percentApperanceStart and percentAppearanceEnd represent the section of appearances that this will use. The
     * first trashable should have a start of 1 and the last should have an end of 100. There should be no overlap
     * of the number ranges, and each start should be equal to the previous end, like this:
     *
     * (1, 10), (10, 35), (35, 60), (60, 100)
     */
    constructor(
        private state: HeroState, private startX: number, private startY: number, asset: string,
        defaultScale: number, group: Phaser.Group, private hide: Phaser.Sprite, private relatedSprite: Phaser.Sprite,
        private appearances: Array<number>, private percentAppearanceStart: number,
        private percentAppearanceEnd: number
    ) {

        super(state.game, startX, startY, asset)

        group.add(this)
        Scale.scaleSprite(this, defaultScale)

        Buttons.makeSpriteButton(this)
        this.input.enableDrag(true)
        this.events.onDragStop.add(this.onDoneDragging)
        this.events.onDragStart.add(() => {
            this.alpha = 1
            this.relatedSprite.frame = 0
            this.hide.visible = false
        })

        this.alpha = 0
        this.hide.visible = false

        this.appearanceTimer = state.game.time.create()
        this.setupAppearances()
    }

    turnOn = () => {
        log.debug("Turning on trashable: " + this.toString())
        this.on = true
        this.relatedSprite.frame = 1
        this.hide.visible = true
        this.input.enabled = true
        this.frame = 1
    }

    turnOff = () => {
        log.debug("Removing trashable: " + this.toString())
        this.on = false
        this.x = this.startX
        this.y = this.startY
        this.input.enabled = false
        this.frame = 0
        this.state.trashedTrashables++
        if (this.state.trashedTrashables === 10) {
            this.state.trashablesCount.x -= Scale.width() * 0.008
        }
        this.state.trashablesCount.text = this.state.trashedTrashables.toString()
        if (this.relatedSprite) {
            this.alpha = 0
        }
    }

    onDoneDragging = () => {
        // Normally would expect this.getBounds() to work, and it does, but causes strange typescript cast issue too.
        const bounds = new Phaser.Rectangle(this.x, this.y, this.height, this.width)
        const trashBounds = new Phaser.Rectangle(this.state.trash.x, this.state.trash.y, this.state.trash.height,
            this.state.trash.width)
        if (Phaser.Rectangle.intersects(bounds, trashBounds)) {
            this.turnOff()
        }
    }

    setupAppearances = () => {
        const multiplyBy = this.appearances.length / 100
        const actualStart = Math.round((this.percentAppearanceStart - 1) * multiplyBy)
        const actualEnd = this.percentAppearanceEnd === 99 ? this.appearances.length :
            Math.round((this.percentAppearanceEnd - 1) * multiplyBy)
        const actualAppearances = this.appearances.slice(actualStart, actualEnd)
        log.debug("Appearances for percents: " + this.percentAppearanceStart + " " + this.percentAppearanceEnd + " "
            + " actualStart: " + actualStart + " actualEnd: " + actualEnd + " " + actualAppearances)
        actualAppearances.forEach((appearance) => {
            const appearanceTime = Math.floor(Math.random() * 500 + appearance - 500)
            this.appearanceTimer.add(appearanceTime, () => {
                if (!this.on) {
                    this.turnOn()
                }
            })
        })
        this.appearanceTimer.start()
    }

    toString = (): string => {
        return "Trashable startX: " + Math.floor(this.startX) + " startY: " + Math.floor(this.startY) + " current" +
            " frame: " + this.frame + " input: " + this.input
    }

}
